module.exports = __webpack_public_path__ + "static/media/Montserrat-LightItalic.dadd3c3b.ttf";